// The Manage Courses review columns for one course's review summary
// (GET /api/courses/<id>/review-summary; null when it failed to load).

const STATUS_SORT = { reviewed: 3, partial: 2, 'has-issues': 1, 'not-reviewed': 0, 'no-cards': 0 };

function reviewStatus(reviewed, total, unresolved) {
    if (total === 0) return 'no-cards';
    if (reviewed === 0) return 'not-reviewed';
    if (unresolved > 0) return 'has-issues';
    if (reviewed < total) return 'partial';
    return 'reviewed';
}

export function reviewColumns(summary) {
    const reviewed = summary?.reviewed_cards || 0;
    const total = summary?.total_cards || 0;
    const unresolved = summary?.unresolved_findings || 0;
    const status = reviewStatus(reviewed, total, unresolved);
    return {
        review_reviewed: reviewed,
        review_total: total,
        review_unresolved: unresolved,
        // Proofread findings count apart: typos never make a course "has issues".
        review_typos: summary?.unresolved_proofread_findings || 0,
        review_status: status,
        review_status_sort: STATUS_SORT[status],
        review_last_ts: summary?.last_review || null,
    };
}
